import React from 'react';
import { Card, Row, Col, Input, Select, Button, Space, Tag } from 'antd';
import { FilterOutlined, ClearOutlined } from '@ant-design/icons';
import styles from '../../pages/admin/Subscribers.module.css';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

interface AgencyFiltersProps {
  filters: {
    name?: string;
    email?: string;
    status?: string;
  };
  setFilters: (filters: any) => void;
  onClearAll: () => void;
}

const AgencyFilters: React.FC<AgencyFiltersProps> = ({ filters, setFilters, onClearAll }) => {
  const { t } = useTranslation();

  const getActiveFilterCount = () => {
    return Object.values(filters).filter(v => v !== undefined && v !== '').length;
  };

  return (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      title={
        <Space>
          <FilterOutlined />
          {t('filters.title')}
          {getActiveFilterCount() > 0 && <Tag color="blue">{getActiveFilterCount()}</Tag>}
        </Space>
      }
    >
      <Row gutter={[16, 16]}>
        {/* Nom agence */}
        <Col xs={24} sm={12} md={8}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>{t('common.name')}</label>
          <Input
            className={styles.customInput}
            placeholder={t('filters.agencyName')}
            value={filters.name || ''}
            onChange={(e) => setFilters(prev => ({ ...prev, name: e.target.value }))}
          />
        </Col>

        {/* Email */}
        <Col xs={24} sm={12} md={8}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>{t('common.email')}</label>
          <Input
            className={styles.customInput}
            placeholder={t('common.email')}
            value={filters.email || ''}
            onChange={(e) => setFilters(prev => ({ ...prev, email: e.target.value }))}
          />
        </Col>

        {/* Statut */}
        <Col xs={24} sm={12} md={8}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>{t('common.status')}</label>
          <Select
            className={styles.customSelect}
            placeholder={t('filters.selectPlaceholder')}
            value={filters.status || undefined}
            onChange={(val) => setFilters(prev => ({ ...prev, status: val }))}
            allowClear
            style={{ width: '100%' }}
          >
            <Option value="ACTIVE">{t('agencyStatus.ACTIVE')}</Option>
            <Option value="WAITING_ACTIVATION">{t('agencyStatus.WAITING_ACTIVATION')}</Option>
            <Option value="AVAILABLE">{t('agencyStatus.AVAILABLE')}</Option>
            <Option value="LOADED">{t('agencyStatus.LOADED')}</Option>
            <Option value="OPERATOR_BARRED">{t('agencyStatus.OPERATOR_BARRED')}</Option>
            <Option value="PRE_ACTIVATED">{t('agencyStatus.PRE_ACTIVATED')}</Option>
            <Option value="SUSPENDED">{t('agencyStatus.SUSPENDED')}</Option>
            <Option value="TARIFF_HOLIDAY">{t('agencyStatus.TARIFF_HOLIDAY')}</Option>
            <Option value="TERMINATED">{t('agencyStatus.TERMINATED')}</Option>
            <Option value="TEST_MODE">{t('agencyStatus.TEST_MODE')}</Option>
          </Select>
        </Col>

        {/* Bouton Réinitialiser */}
        <Col xs={24} sm={24} md={8}>
          <div style={{ paddingTop: 24 }}>
            <Space>
              <Button
                icon={<ClearOutlined />}
                onClick={onClearAll}
                disabled={getActiveFilterCount() === 0}
              >
                {t('filters.reset')}
              </Button>
              {getActiveFilterCount() > 0 && <Tag color="blue">{getActiveFilterCount()} {t('filters.activeFilters')}</Tag>}
            </Space>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default AgencyFilters;
